module.exports = __webpack_public_path__ + "img/paytable_icon.a70f5677.svg";